import { selectProfileId } from '@store/slices/account/accountSlice.js';
import httpClient from '@utils/httpClient';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import { blocksMergeMeta, blocksRefreshMetaRequest } from './blocksSlice.js';

function fetchBlocksMeta(profileId) {
  return httpClient.get(`/api/profiles/${profileId}/blocks/meta`);
}

function* refreshBlocksMetaSaga() {
  try {
    const profileId = yield select(selectProfileId);
    if (!profileId) return;

    const { data } = yield call(fetchBlocksMeta, profileId);
    const list = Array.isArray(data?.list) ? data.list : [];
    yield put(blocksMergeMeta(list));
  } catch {
    // Silent — meta is non-critical UI sugar; old badges stay until next successful refresh.
  }
}

export function* blocksMetaWatcher() {
  yield takeLatest(blocksRefreshMetaRequest.type, refreshBlocksMetaSaga);
}
